export default {
  CUSTOM: '/saas-custom-api',
  IMS: '/saas-core-ims'
}
